import React, { Component } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Avatar from "@mui/material/Avatar";
import { NavLink } from "react-router-dom";
import { checkPrivileges } from "../../Helpers";
import Style from "style-it";

const isUserDisabled = (user) =>
  user?.disabled === true || user?.disabled === "on" || user?.disabled === 1;

const statusStyles = `
  .user-list-row-content {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
  }
  .user-list-row-content .checkbox {
    flex: 1 1 auto;
    min-width: 0;
    margin: 0;
  }
  .user-list-row-content .unit-name {
    max-width: 65% !important;
    min-width: 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .user-status-link {
    flex: 0 0 auto;
    font-size: 12px;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
  }
  .user-status-link.active-status {
    color: #2e9e8f;
  }
  .user-status-link.inactive-status {
    color: #e53935;
  }
  .user-list-row-content .pull-right {
    flex: 0 0 auto;
  }
`;

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usesId: "",
      userProcess: true,
    };
  }

  render() {
    let data = "";
    if (this.props.users.length) {
      data = this.props.users.map((user) => (
        <ListRow
          key={user.id}
          data={user}
          {...this.props}
          removedItem={this.props.removedItem}
          editItem={this.props.editItem}
          selecteItem={this.props.selecteItem}
          selectedItemId={this.props.selectedItemId}
          toggleUserStatus={this.props.toggleUserStatus}
        />
      ));
    }

    return (
      <Style>
        {`
					.material-icons {vertical-align: middle; color: inherit}
          ${statusStyles}
				`}
        <div>
          {data && (
            <div className="individual-view">
              <ul className="list-view">{data}</ul>
            </div>
          )}
        </div>
      </Style>
    );
  }
}

export class ListRow extends Component {
  checkUserType = (Utype) => {
    let type = "";
    if (Utype === -1) {
      type = "O";
    } else if (Utype === 1) {
      type = "U";
    } else if (Utype === 2) {
      type = "A";
    } else if (Utype === 3) {
      type = "AA";
    } else if (Utype === 4) {
      type = "SP";
    } else if (Utype === 5) {
      type = "R";
    } else if (Utype === 6) {
      type = "D";
    } else {
      type = "U";
    }
    return type;
  };

  handleStatusClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.toggleUserStatus) {
      this.props.toggleUserStatus(this.props.data);
    }
  };

  render() {
    const empty = null;
    const inactive = isUserDisabled(this.props.data);
    return (
      <li>
        <a
          href={empty}
          className={
            "clearfix list-row " +
            (this.props.selectedItemId === this.props.data.id ? "active" : "")
          }
        >
          <div className="user-list-row-content">
            <label
              className="checkbox"
              onClick={() => this.props.selecteItem(this.props.data)}
            >
              <span
                className="unit-name"
                style={{
                  lineHeight: "24px",
                }}
              >
                <span
                  style={{
                    marginRight: "10px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                >
                  <Avatar
                    className={
                      "avatar-" + this.checkUserType(this.props.data.userType)
                    }
                    style={{ width: 25, height: 25, fontSize: 12 }}
                  >
                    {this.checkUserType(this.props.data.userType)}
                  </Avatar>
                </span>{" "}
                {this.props.data.name} {this.props.data.uniqueId}
              </span>
            </label>
            <span
              className={
                "user-status-link " +
                (inactive ? "inactive-status" : "active-status")
              }
              onClick={this.handleStatusClick}
              title={
                inactive
                  ? this.props.translate("makeUserActive")
                  : this.props.translate("makeUserInactive")
              }
            >
              {inactive
                ? this.props.translate("InActive")
                : this.props.translate("active")}
            </span>
            {this.props.logInUser.administrator && (
              <div className="pull-right">
                {checkPrivileges("userDelete") && (
                  <span
                    className="action-item hovered "
                    title={this.props.translate("delete")}
                    onClick={() => this.props.removedItem(this.props.data)}
                  >
                    <DeleteIcon style={{ fontSize: 16 }} />
                  </span>
                )}
                <span
                  className="action-item hovered"
                  title={this.props.translate("edit")}
                  onClick={() => this.props.editItem(this.props.data)}
                >
                  {" "}
                  <EditIcon style={{ fontSize: 16 }} />
                </span>
              </div>
            )}
          </div>
        </a>
      </li>
    );
  }
}

class Users2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usesId: "",
      userProcess: false,
    };
  }

  render() {
    let data = "";
    if (this.props.users.length) {
      data = this.props.users.map((user) => {
        return (
          <ListRow2
            key={user.id}
            data={user}
            {...this.props}
            removedItem={this.props.removedItem}
            editItem={this.props.editItem}
            toggleUserStatus={this.props.toggleUserStatus}
          />
        );
      });
    }

    return (
      <Style>
        {statusStyles}
        <div>
          {data && (
            <div className="individual-view">
              <ul className="list-view">{data}</ul>
            </div>
          )}
        </div>
      </Style>
    );
  }
}

export class ListRow2 extends Component {
  checkUserType = (Utype) => {
    let type = "";
    if (Utype === -1) {
      type = "O";
    } else if (Utype === 1) {
      type = "U";
    } else if (Utype === 2) {
      type = "A";
    } else if (Utype === 3) {
      type = "AA";
    } else if (Utype === 4) {
      type = "SP";
    } else if (Utype === 5) {
      type = "R";
    } else if (Utype === 6) {
      type = "D";
    } else {
      type = "U";
    }
    return type;
  };

  handleStatusClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.toggleUserStatus) {
      this.props.toggleUserStatus(this.props.data);
    }
  };

  render() {
    const inactive = isUserDisabled(this.props.data);
    return (
      <li>
        <NavLink
          activeClassName="active"
          to={"/users/" + this.props.data.id}
          className={"clearfix list-row"}
        >
          <div className="user-list-row-content">
            <label className="checkbox">
              <span className="unit-name">
                <span
                  style={{
                    marginRight: "10px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                >
                  <Avatar
                    className={
                      "avatar-" + this.checkUserType(this.props.data.userType)
                    }
                    style={{ width: 18, height: 18, fontSize: 10 }}
                  >
                    {this.checkUserType(this.props.data.userType)}
                  </Avatar>
                </span>{" "}
                {this.props.data.name} {this.props.data.uniqueId}
              </span>
            </label>
            <span
              className={
                "user-status-link " +
                (inactive ? "inactive-status" : "active-status")
              }
              onClick={this.handleStatusClick}
              title={
                inactive
                  ? this.props.translate("makeUserActive")
                  : this.props.translate("makeUserInactive")
              }
            >
              {inactive
                ? this.props.translate("InActive")
                : this.props.translate("active")}
            </span>
            {this.props.logInUser.administrator &&
              checkPrivileges("userDelete") && (
                <div className="pull-right">
                  <span
                    className="action-item "
                    title={this.props.translate("delete")}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.props.removedItem(this.props.data);
                    }}
                  >
                    <DeleteIcon style={{ fontSize: 16 }} />
                  </span>
                </div>
              )}
          </div>
        </NavLink>
      </li>
    );
  }
}

export const UsersShortList = Users;
export const UsersShortList2 = Users2;
